<script setup>
import CToast from "@/Components/CToast.vue"
import {onBeforeUnmount, onMounted, ref} from "vue"
import {eventBus} from "@/Services/eventBus.js"

const toast = ref(null)

const emitToast = (payload) => {
    toast.value.emit(payload.message, payload.type, payload.options)
};

onMounted(() => {
    eventBus.on('emitToast', emitToast);
});

onBeforeUnmount(() => {
    eventBus.off('emitToast', emitToast);
});
</script>

<template>
    <c-toast ref="toast"/>
</template>
